import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { NewVessel, NewVesselMode } from './model';
import { EditNewVesselOverridesView } from 'portcall/editnewvesseloverrides/view';
import { ExternalVesselSearchView } from 'portcall/externalvesselsearch/view';

export const NewVesselView = SuperCritical(({model, prevSearch} : { model : NewVessel, prevSearch?: string }) =>
    model.Mode() === NewVesselMode.ExternalVesselService 
        ? <ExternalVesselSearchView model={model.VesselSearch} prevSearch={prevSearch} />
        : <EditNewVesselOverridesView model={model.EditOverrides} />
);


// WEBPACK FOOTER //
// ./apps/portcall/newvessel/view.tsx